import { ReactComponent } from "./filter-line.svg";

const FilterLineIcon = () => <ReactComponent />;

export default FilterLineIcon;
